<template>
  <div class="nav-container">
    <div class="nav"> 
      <BtnDownloadExcel
        v-if="!has0Import"
        v-on:load-spinner="showSpinner" 
         v-on:hide-spinner="disableSpinner"
      />
      <BtnUploadExcel
        v-if="!has0Import"
        @loadSpinner="showSpinner"
        @hideSpinner="disableSpinner"
      />
      <BtnMenuAvantOptim v-if="!has0Import" />
      <BtnLaunchOptim
        v-if="!has0Import"
        @loadSpinner="showSpinner"
        @hideSpinner="disableSpinner"
      />
      <BtnMenuApresOptim v-if="!has0Import" />
      <BtnExportExcel
        v-if="!has0Import"
        @loadSpinner="showSpinner"
        @hideSpinner="disableSpinner"
      />
      <BtnAdmin v-if="isViewer === false" />
      <BtnQuit />
    </div>
  </div>
</template>
<script>
import BtnUploadExcel from './Button/BtnUploadExcel';
import BtnMenuAvantOptim from './Button/BtnMenuAvantOptim';
import BtnLaunchOptim from './Button/BtnLaunchOptim';
import BtnMenuApresOptim from './Button/BtnMenuApresOptim';
import BtnExportExcel from './Button/BtnExportExcel';
import BtnDownloadExcel from './Button/BtnDownloadExcel';
import BtnAdmin from './Button/BtnAdmin';
import BtnQuit from './Button/BtnQuit';
export default {
  components: {
    BtnDownloadExcel,
    BtnUploadExcel,
    BtnMenuAvantOptim,
    BtnLaunchOptim,
    BtnMenuApresOptim,
    BtnExportExcel,
    BtnAdmin,
    BtnQuit,
  },
  props: {
    has0Import: Boolean,
  },
  data() {
    return {
      spinnerShown: false,
    };
  },
  computed: {
    isViewer: {
      get() {
        return this.$store.state.userInfos.isViewer;
      },
    },
  },
  methods: {
    showSpinner: function(message) {
      this.$emit('load-spinner', message);
    },
    disableSpinner() {
      this.$emit('hide-spinner');
    },
  },
};
</script>

<style scoped>
.nav-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  position: relative;
}
.nav {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.spinner-container {
  position: absolute;
  top: 40px;
}
</style>
